export function currencyParser(c: string | number | undefined): number {
  const isOkay = /^\d+(,\d{3})*(\.\d{1,2})?$/.test('' + c);
  const curr = `${c}`.replace(/,/g, '');
  return isOkay ? parseFloat(curr) : NaN;
}

export function isCurrency(c: string | number | undefined): boolean {
  return !isNaN(currencyParser(c));
}
